import NavMenu from "../../navMenu.js";
import mobileMenu from "./mobileMenu.js";

export default (el, index) => {
  const headerEl = document.querySelector("header");
  const bodyEl = document.querySelector("body");

  el.querySelectorAll(".js-mobile-nav-menu").forEach((el, i) => {
    mobileMenu(el, i);
  });

  const onClose = () => {
    headerEl.style.position = "";
    headerEl.style.top = "";
    headerEl.style.zIndex = "";
    bodyEl.style.overflow = "";
  };

  const onOpen = () => {
    headerEl.style.position = "sticky";
    headerEl.style.top = "0";
    headerEl.style.zIndex = "3";
    bodyEl.style.overflow = "hidden";
  };

  NavMenu({
    animationDelay: 800,
    closed: true,
    direction: "vertical",
    menuButton: ".js-nav-toggle",
    menuContainer: ".js-mobile-menu-content",
    navigationLink: ".js-mobile-nav-menu",
    openClass: "is-open",
    onClose: onClose,
    onOpen: onOpen,
    parent: el,
  });
};;
